import React from 'react';
import Card from './Card';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Wrapper>
            <div className="tvSection">
                <Card/>
            </div>

            <div className="textBox">
                <h1>{t('notFoundPage.title')}</h1>
                <p>
                    {t('notFoundPage.description')}
                </p>

                <button onClick={() => navigate('/')}>
                    {t('notFoundPage.goHome')}
                </button>
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    background: #F0F4FD;
    color: black;

    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 40px 20px;

    .tvSection {
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scale(0.9);
    }

    .textBox {
        text-align: center;
        max-width: 420px;
        margin-top: 20px;
    }

    h1 {
        font-size: 22px;
    }

    p {
        font-size: 14px;
        opacity: 0.75;
        margin: 10px 0 20px;
    }

    button {
        padding: 10px 18px;
        border: none;
        border-radius: 8px;
        background: #327EF8;
        color: black;
        font-weight: bold;
        cursor: pointer;
    }

    button:hover {
        background: #156af8;
    }
`;